module.exports = __webpack_public_path__ + "img/stage-manager-10.png";